import styled from 'styled-components';

const Wrapper = styled.section`
  min-height: 60vh;
  display: grid;
  place-items: center;

  .img-container {
    display: none;
  }

  h1{
     span{
      color: var(--clr-primary-5);
     }
  }

  p {
    line-height: 1.5;
    max-width: 45em;
    margin-bottom: 2rem;
    color: var(--clr-grey-3);
    font-size: 1rem;
  }
  @media (min-width: 992px) {
    height: calc(100vh - 5rem);
    grid-template-columns: 1fr 1fr;
    gap: 8rem;
    h1 {
      margin-bottom: 2rem;
    }
    p {
      font-size: 1.20rem;
    }
    .hero-btn {
      padding: 0.70rem 1rem;
      font-size: 1rem;
      text-transform: capitalize;
    }
    .img-container {
      display: block;
      position: relative;
      justify-self: end;
    }
    .main-img {
      width: 100%;
      height: 500px;
      position: relative;
      border-radius: var(--radius);
      display: block;
      object-fit: cover;
    }
    .accent-img {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 250px;
      transform: translateX(-50%);
      border-radius: var(--radius);
    }
    .img-container::before {
      content: '';
      position: absolute;
      width: 10%;
      height: 80%;
      background: var(--clr-primary-8);
      bottom: 0%;
      left: -8%;
      border-radius: var(--radius);
    }
  }
`

export default Wrapper;
